'use client';

import { c as _c } from "react/compiler-runtime";
import type { DocumentoPadrao } from '@/features/documentosPadrao/types/documentosPadraoTypes';
import { Button } from '@/shared/components/ui/common/Button';
import { IconDialog } from '@/shared/components/ui/common/IconDialog';
import { FeatherArchive } from '@subframe/core';
interface DocumentoPadraoArquivarDialogProps {
  aberto: boolean;
  documento: DocumentoPadrao | null;
  salvando: boolean;
  onFechar: () => void;
  onConfirmar: (documento: DocumentoPadrao) => void;
}
export function DocumentoPadraoArquivarDialog(t0) {
  const $ = _c(22);
  const {
    aberto,
    documento,
    salvando,
    onFechar,
    onConfirmar
  } = t0;
  if (!documento) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherArchive />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onFechar) {
    t2 = estado => {
      if (!estado) {
        onFechar();
      }
    };
    $[1] = onFechar;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `“${documento.nome}” sai das sugestões de todos os produtos e não pode mais ser anexado. O que já foi protocolado continua válido, e você pode restaurar o documento depois.`;
  let t4;
  if ($[3] !== onFechar || $[4] !== salvando) {
    t4 = <Button variant="neutral-secondary" onClick={onFechar} disabled={salvando}>Cancelar</Button>;
    $[3] = onFechar;
    $[4] = salvando;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherArchive />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== documento || $[8] !== onConfirmar) {
    t6 = () => onConfirmar(documento);
    $[7] = documento;
    $[8] = onConfirmar;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== salvando || $[11] !== t6) {
    t7 = <Button icon={t5} loading={salvando} disabled={salvando} onClick={t6}>Arquivar</Button>;
    $[10] = salvando;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== aberto || $[17] !== onFechar || $[18] !== t2 || $[19] !== t3 || $[20] !== t8) {
    t9 = <IconDialog open={aberto} tone="warning" icon={t1} title={"Arquivar documento padr\xE3o"} onOpenChange={t2} onFechar={onFechar} description={t3} footer={t8} />;
    $[16] = aberto;
    $[17] = onFechar;
    $[18] = t2;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}